export default __webpack_public_path__ + "static/media/Logo_CN.6600edfa.png";